<app-modal #modal [hideFooter]="true">
  <div class="app-modal-header" >
    {{type | translate}}
  </div>
  <div class="app-modal-body text-center">
    <app-auth-signin-general *ngIf="type==='signin'" [showBg] = false (changeTub) = "changeModalTub($event)" (closeModal) = "modal.hide()" [shouldRouting] = 'false'></app-auth-signin-general>
    <app-auth-signin-general *ngIf="type === 'signup'" [showBg] = false (changeTub)= "changeModalTub($event)" (closeModal) = "modal.hide()" [shouldRouting] = 'false'> </app-auth-signin-general>
  </div>
</app-modal>
<div class="flex items-center justify-center gap-x-6">
    <div>
        <app-language-changer forPlace="header"></app-language-changer>
    </div>

    <app-button
            *ngIf="isLoginPage"
            [text]="'signup'"
            (onClick)="openModal('signup')">
    </app-button>

    <app-button
            *ngIf="!isLoginPage"
            [text]="'signin'"
            (onClick)="openModal('signin')">
    </app-button>
</div>

